import currentRouteId from 'root/src/client/logic/route/selectors/currentRouteId'
import { ADD_TO_SEND_GRID_LIST } from 'root/src/shared/descriptions/endpoints/endpointIds'
import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import clearForm from 'root/src/client/logic/form/actions/clearForm'
import { SUCCESS_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import displayModal from 'root/src/client/logic/modal/thunks/displayModal'

const listNameMap = {
	PUBLISHERS_PAGE_ROUTE_ID: 'Brand',
}

export default (formData, { moduleKey, moduleId }) => async (dispatch, getState) => {
	const { email } = formData
	const listName = listNameMap[currentRouteId(getState())]
	const { error } = await dispatch(
		apiRequest(ADD_TO_SEND_GRID_LIST, { email, listName }),
	)
	if (!error) {
		dispatch(
			displayModal(SUCCESS_MODAL_MODULE_ID, {
				header: 'We’ll Keep In Touch!',
				infoText: 'Reach out any time for a conversation.',
			}),
		)
	}
	dispatch(clearForm({ moduleId, moduleKey }))
}
